import * as React from "react";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import styles from "./Report.style";
import { CircularProgress, Modal, Button, Select } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";

import { toast, ToastContainer } from "react-toastify";
import { TextField } from "@mui/material";

import { apiURLs } from "./config";

import _ from "lodash";
import { AddCircle } from "@mui/icons-material";
import RemoveCircle from "@mui/icons-material/RemoveCircle";

const EditableText = (props) => {
  const [value, setValue] = useState(props.value);
  const [editing, setEditing] = useState(props.edit || false);
  const inputRef = useRef(null);
  const { width = "80%" } = props;
  const { textStyle = styles.textStyle } = props;
  const { inputType = "text" } = props;
  React.useEffect(() => {
    // console.log('changing value...', props.value, value);
    setValue(props.value);
  }, [props.value]);

  return (
    <div style={styles.editInputWrapper}>
      {editing ? (
        <div style={styles.editRow}>
          <input
            style={styles.editInput(width)}
            ref={inputRef}
            type={inputType}
            value={value}
            onChange={(e) => {
              // console.log('chaning value')
              setValue(e.target.value);
            }}
            onBlur={(e) => {
              console.log("focus out...");
              setEditing(false);
              props.onChange(value);
            }}
          />

          <SaveIcon
            onClick={() => {
              setEditing(false);
              props.onChange(value);
            }}
          />
        </div>
      ) : (
        <div style={styles.editRow}>
          <span style={textStyle}>{value}</span>
          <EditIcon style={styles.editIcon} onClick={() => setEditing(true)} />
        </div>
      )}
    </div>
  );
};

export default function Report(props) {
  const { jobId } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cacsData, setCacsData] = useState(null);
  const [originalCacsData, setOriginalCacsData] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const [arteriesFindings, setArteriesFindings] = useState(null);
  const [aortaData, setAortaData] = useState(null);
  const [totalCacScore, setTotalCacScore] = useState(0);
  const [impressions, setImpressions] = useState([]);
  const [pericardilFat, setPericardialFat] = useState(0);
  const [cacModalOpen, setCacModalOpen] = useState(false);
  const [newCacData, setNewCacData] = useState({});
  const [otherOrgans, setOtherOrgans] = useState({});
  const [editableText, setEditableText] = useState("XYZ"); // Initial editable text

  const [editableArray, setEditableArray] = useState([
    "Stent detected in XYZ", // Editable text
    "Presence of stent may affect the Agatston Score",
  ]);

  const handleEdit = (index, newValue) => {
    const updatedArray = [...editableArray];
    updatedArray[index] = newValue;
    setEditableArray(updatedArray);
  };

  // const [ baseURL, setBaseURL ] = useState('');
  const [baseURLAPI, setBaseURLAPI] = useState("");
  const [center, setCenter] = useState("");
  const [admin, setAdmin] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [config, setConfig] = useState("original");

  const [saving, setSaving] = useState(false);

  const [allowEditImpressions, setAllowEditImpressions] = useState(false);

  const token = admin
    ? localStorage.getItem(`token-${center}`)
    : localStorage.getItem("token");

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [mobile, setMobile] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    });
  }, []);

  React.useEffect(() => {
    if (dimensions.width < 600) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [dimensions]);

  console.log(mobile);

  console.log(mobile);

  React.useEffect(() => {
    console.log("getting center and admin");
    // get center from local storage
    const center = localStorage.getItem("center");
    const admin = localStorage.getItem("admin");

    setCenter(center);
    setAdmin(admin === "true");

    console.log(center, admin, "center and admin");

    // setBaseURL(inferURLs[center]);
    setBaseURLAPI(apiURLs[center]);
  }, []);

  React.useEffect(() => {
    if (baseURLAPI === "") return;
    if (saving) return;
    // get configs
    axios
      .get(`${apiURLs[center]}/configs?job_id=${jobId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("configs", res.data);
        let configs = res.data.configs;
        setConfigs(configs);
        setConfig(configs[configs.length - 1]);
        console.log("config", res.data.configs[res.data.configs.length - 1]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [baseURLAPI, saving]);

  React.useEffect(() => {
    if (baseURLAPI === "") return;
    console.log("getting report data...");
    axios
      .get(`${baseURLAPI}/json?job_id=${jobId}&config_name=${config}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("cacs", res);
        let cacs = {};
        for (let i = 0; i < res.data.cacs.length; i++) {
          cacs[`cac_${i + 1}`] = res.data.cacs[i];
          // cacs[`cac_${i + 1}`].staghorn = cacs[`cac_${i + 1}`].staghorn ? 1 : 0;
        }
        console.log("cacs", cacs);
        setOriginalCacsData(cacs);
        setCacsData(cacs);
        setPatientData(res.data.patient);
        setArteriesFindings(res.data.arteries_findings);
        setAortaData(res.data.aorta);
        setTotalCacScore(res.data.total_cac_score);
        setImpressions(res.data.impressions);
        setPericardialFat(res.data.pericardial_fat);

        // setImpressions('No Impression');

        console.log("cacs", cacs);
        console.log("patient", res.data.patient);
        console.log("aorta", res.data.aorta);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [baseURLAPI, config]);

  const onDownloadReport = () => {
    axios({
      method: "GET",
      url: `${baseURLAPI}/pdf?job_id=${jobId}&config_name=${config}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "arraybuffer",
    })
      .then((res) => {
        // download file
        console.log("res", res);
        let blob = new Blob([res.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = "report.pdf";
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSaveReport = () => {
    setSaving(true);
    console.log("saving report...");
    console.log(config, "config");
    console.log(totalCacScore, "total cac score");
    // console.log(patientData, 'patient data');
    axios({
      method: "POST",
      url: `${baseURLAPI}/pdf?job_id=${jobId}&config_name=${config}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        // patient: patientData,
        // total_cac_score: totalCacScore,
        arteries_findings: arteriesFindings,
        impressions: impressions,
        aorta: aortaData,
        pericardial_fat: pericardilFat,
        // cacs: cacsData,
        // deep: _.isEqual(cacsData, originalCacsData) ? false : true,
      },
    })
      .then((res) => {
        // download file
        console.log("res", res);
        // toast.success('Report saved successfully');
        // wait for task to finish
        let interval = setInterval(() => {
          // every 1 second
          axios
            .get(`${baseURLAPI}/task_status/${res.data.task_id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => {
              console.log("task", res);
              if (res.data.status === "SUCCESS") {
                clearInterval(interval);
                setSaving(false);
                toast.success("Report saved successfully");
              }
              if (props.onConfigSaved) {
                console.log("calling onConfigSaved");
                props.onConfigSaved();
              }
            })
            .catch((err) => {
              console.log(err);
              setSaving(false);
              toast.error("Error saving report");
            });
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        setSaving(false);
        toast.error("Error saving report");
      });
  };

  const onReportGen = () => {
    setSaving(true);
    // send to backend
    let url = `${baseURLAPI}/gen_report`;
    const token = admin
      ? localStorage.getItem(`token-${center}`)
      : localStorage.getItem("token");
    let data = {
      job_id: jobId,
      config: config,
    };
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        let interval = setInterval(() => {
          // every 1 second
          axios
            .get(`${baseURLAPI}/task_status/${res.data.task_id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => {
              console.log("task", res);
              if (res.data.status === "SUCCESS") {
                clearInterval(interval);
                setSaving(false);
                toast.success("Report Generated successfully");
              }
              if (props.onConfigSaved) {
                console.log("calling onConfigSaved");
                props.onConfigSaved();
              }
            })
            .catch((err) => {
              console.log(err);
              setSaving(false);
              toast.error("Error generating report");
            });
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        setSaving(false);
        toast.error("Error generating report");
      });
  };

  const allImpressions = Array.from(
    new Set([...editableArray, ...impressions]),
  );

  const handleAortaValueChange = (location, field, newValue) => {
    const numValue = parseFloat(newValue);

    setAortaData((prev) => ({
      ...prev,
      [location]: {
        ...prev[location],
        [field]: numValue,
      },
    }));
  };

  const formatLabel = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const isValueInRange = (value, range) => {
    return value <= range;
  };
  // console.log('cac data', cacsData);
  return (
    <>
      {!loading ? (
        <div style={mobile ? styles.rootMobile : styles.root}>
          <div style={mobile ? styles.pageHeaderMobile : styles.pageHeader}>
            <div>
              Config:
              <Select
                value={config}
                style={
                  mobile ? styles.configsSelectMobile : styles.configsSelect
                }
                onChange={(e) => {
                  setConfig(e.target.value);
                }}
              >
                {configs.map((config, i) => {
                  return (
                    <MenuItem key={i} value={config}>
                      {config}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
            <Button
              onClick={onSaveReport}
              style={mobile ? styles.saveButtonMobile : styles.saveButton}
            >
              Save
              <DownloadIcon
                style={mobile ? styles.downloadIconMobile : styles.downloadIcon}
              />
            </Button>
            <Button
              onClick={onReportGen}
              style={mobile ? styles.saveButtonMobile : styles.saveButton}
            >
              Generate Report
              <DownloadIcon
                style={mobile ? styles.downloadIconMobile : styles.downloadIcon}
              />
            </Button>
            <Button
              onClick={onDownloadReport}
              style={
                mobile ? styles.downloadButtonMobile : styles.downloadButton
              }
            >
              Download
              <DownloadIcon
                style={mobile ? styles.downloadIconMobile : styles.downloadIcon}
              />
            </Button>
            {saving ? <CircularProgress style={styles.progress} /> : null}
          </div>
          <div style={{ width: "100%" }}>
            <div style={styles.header}>
              <p
                style={{ height: "10px", fontWeight: "800", fontSize: "18pt" }}
              >
                Study: CT Calcium Scoring of Heart
              </p>
              <div style={styles.header2}>
                <div style={styles.headerLeft}>
                  <span style={styles.patientText}>
                    Bill ID: &nbsp; {patientData.patient_id}
                  </span>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={styles.patientText}>
                      Name: {patientData.patient_name}
                    </div>
                    <div style={styles.patientText}>
                      {" "}
                      Age: {patientData.age}
                    </div>
                    <div style={styles.patientText}>
                      {" "}
                      Sex: {patientData.sex}
                    </div>
                  </div>
                </div>
                <div style={styles.headerRight}>
                  <span style={styles.patientText}>
                    Study Date: &nbsp; &nbsp; {patientData.study_date}
                  </span>
                  <span style={styles.patientText}>
                    Referring Doctor: &nbsp; &nbsp;{" "}
                    {patientData.referring_doctor}
                  </span>
                </div>
              </div>
            </div>
            <div style={mobile ? styles.contentMobile : styles.content}>
              {/* <div style={styles.cacHeader}>
                            <p style={styles.cacHeaderText}>Total CAC Score: </p>
                            <div style={{width:'10%', textAlign: 'center'}}>
                                <EditableText textStyle={{fontSize: '17pt'}}  value={totalCacScore} onChange={(value) => {setTotalCacScore(value)}}/>
                            </div>
                        </div> */}

              <div style={styles.headerTextWrapper}>
                <h1 style={styles.headerText}>Arteries Findings</h1>
              </div>
              <div style={{ width: "100%", overflowX: "auto" }}>
                <table
                  style={mobile ? styles.kidneyTableMobile : styles.kidneyTable}
                >
                  <tr>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      Artery
                    </th>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      # Lesions
                    </th>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      Area(mm<sup>2</sup>)
                    </th>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      AS
                    </th>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      VS(mm<sup>2</sup>)
                    </th>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      MS(mg/cm<sup>3</sup>)
                    </th>
                  </tr>
                  <tr>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      LM
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LM.lesions}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LM: { ...arteriesFindings.LM, lesions: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LM.area}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LM: { ...arteriesFindings.LM, area: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LM.as_score}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LM: { ...arteriesFindings.LM, as_score: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LM.volume}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LM: { ...arteriesFindings.LM, volume: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LM.ms}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LM: { ...arteriesFindings.LM, ms: value },
                          });
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      LAD
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LAD.lesions}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LAD: { ...arteriesFindings.LAD, lesions: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LAD.area}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LAD: { ...arteriesFindings.LAD, area: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LAD.as_score}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LAD: { ...arteriesFindings.LAD, as_score: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LAD.volume}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LAD: { ...arteriesFindings.LAD, volume: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LAD.ms}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LAD: { ...arteriesFindings.LAD, ms: value },
                          });
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      LCX
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LCX.lesions}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LCX: { ...arteriesFindings.LCX, lesions: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LCX.area}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LCX: { ...arteriesFindings.LCX, area: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LCX.as_score}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LCX: { ...arteriesFindings.LCX, as_score: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LCX.volume}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LCX: { ...arteriesFindings.LCX, volume: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.LCX.ms}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            LCX: { ...arteriesFindings.LCX, ms: value },
                          });
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      RCA
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.RCA.lesions}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            RCA: { ...arteriesFindings.RCA, lesions: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.RCA.area}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            RCA: { ...arteriesFindings.RCA, area: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.RCA.as_score}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            RCA: { ...arteriesFindings.RCA, as_score: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.RCA.volume}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            RCA: { ...arteriesFindings.RCA, volume: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.RCA.ms}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            RCA: { ...arteriesFindings.RCA, ms: value },
                          });
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      Total
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.total.lesions}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            total: {
                              ...arteriesFindings.total,
                              lesions: value,
                            },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.total.area}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            total: { ...arteriesFindings.total, area: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.total.as_score}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            total: {
                              ...arteriesFindings.total,
                              as_score: value,
                            },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.total.volume}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            total: { ...arteriesFindings.total, volume: value },
                          });
                        }}
                      />
                    </td>
                    <td
                      style={mobile ? styles.tableItemMobile : styles.tableItem}
                    >
                      <EditableText
                        value={arteriesFindings.total.ms}
                        onChange={(value) => {
                          setArteriesFindings({
                            ...arteriesFindings,
                            total: { ...arteriesFindings.total, ms: value },
                          });
                        }}
                      />
                    </td>
                  </tr>
                </table>
              </div>
              <div style={styles.headerTextWrapper}>
                <h1 style={styles.abdomenOrganHeader}>Impression:</h1>
              </div>
              <div style={styles.impressionWrapper}>
                {allImpressions.map((impression, index) => (
                  <div key={index} style={styles.impressionText}>
                    <IconButton
                      onClick={() => {
                        if (impressions.includes(impression)) {
                          setImpressions(
                            impressions.filter((item) => item !== impression),
                          );
                        } else {
                          setImpressions([...impressions, impression]);
                        }
                        console.log(impressions);
                      }}
                    >
                      {impressions.includes(impression) ? (
                        <RemoveCircle sx={{ color: "red" }} />
                      ) : (
                        <AddCircle sx={{ color: "green" }} />
                      )}
                    </IconButton>

                    <TextField
                      value={impression}
                      onChange={(e) => handleEdit(index, e.target.value)}
                      variant="standard"
                      size="small"
                      sx={{ width: "50%" }} // Adjust width as needed
                    />
                  </div>
                ))}
              </div>

              {/* {admin ? (
                            <div style={styles.addStoneRow}>
                            <Switch
                                checked={allowEditImpressions}
                                onChange={(value) => {
                                setAllowEditImpressions(!allowEditImpressions);
                                }}
                            />
                            <IconButton
                                onClick={() => {
                                    setCacModalOpen(true);
                                }}
                            >
                                <AddCircle sx={{ color: "green" }} />
                            </IconButton>
                            </div>
                        ) : null} */}
              <div style={styles.headerTextWrapper}>
                <h1 style={styles.headerText}>Aorta Calculations:</h1>
              </div>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                      Location
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                      Index
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                      Value (mm)
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                      Range (mm)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(aortaData)
                    .sort((a, b) => a[1].index - b[1].index)
                    .map(([location, data]) => {
                      const inRange = isValueInRange(data.val, data.range);
                      return (
                        <tr key={location} className="hover:bg-gray-50">
                          <td className="border border-gray-300 px-4 py-3 font-medium">
                            {formatLabel(location)}
                          </td>
                          <td className="border border-gray-300 px-4 py-3">
                            <input
                              type="number"
                              value={aortaData[location]?.index ?? ""}
                              onChange={(e) =>
                                handleAortaValueChange(
                                  location,
                                  "index",
                                  e.target.value,
                                )
                              }
                              className="w-20 px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-3">
                            <input
                              type="number"
                              step="0.01"
                              value={aortaData[location]?.val ?? ""}
                              onChange={(e) =>
                                handleAortaValueChange(
                                  location,
                                  "val",
                                  e.target.value,
                                )
                              }
                              className="w-28 px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-3">
                            <input
                              type="number"
                              step="0.1"
                              value={aortaData[location]?.range}
                              onChange={(e) =>
                                handleAortaValueChange(
                                  location,
                                  "range",
                                  e.target.value,
                                )
                              }
                              className="w-24 px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <div style={styles.headerTextWrapper}>
                <h1 style={styles.headerText}>Pericardial Fat:</h1>
                <table style={styles.kidneyTable}>
                  <tr>
                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      Pericardial Fat:
                    </th>

                    <th
                      style={
                        mobile
                          ? styles.tableHeaderItemMobile
                          : styles.tableHeaderItem
                      }
                    >
                      Normal Range
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <EditableText
                        inputType={'number'}
                        value={pericardilFat}
                        onChange={(value) => {
                          setPericardialFat(value);
                        }}
                      />{" "}
                      ml
                    </td>
                    <td>&#60; 0.24L</td>
                  </tr>
                </table>
              </div>

              {/* <div style={styles.headerTextWrapper}>
                            <h1 style={styles.headerText}>Aorta Calculations:</h1>
                        </div>
                        <table style={styles.kidneyTable}>
                            <tr>
                                <th style={mobile ? styles.tableHeaderItemMobile : styles.tableHeaderItem}>
                                    Segmentsof Aorta
                                </th>
                                <th style={mobile ? styles.tableHeaderItemMobile : styles.tableHeaderItem}>
                                    Diameter (in mm)
                                </th>
                                <th style={mobile ? styles.tableHeaderItemMobile : styles.tableHeaderItem}>
                                    Normal Range (in mm)
                                </th>
                            </tr>
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Sinus of Valsalva 
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.sinus_of_valsalva} onChange={(value) => { setAortaData({...aortaData, sinus_of_valsalva: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 41.5 
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Sinotubular Junction 
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.sinotubular_junction} onChange={(value) => { setAortaData({...aortaData, sinotubular_junction: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt;  36.9
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Mid Ascending Aorta
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.mid_ascending_aorta} onChange={(value) => { setAortaData({...aortaData, mid_ascending_aorta: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 32.2  
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Proximal Aortic Arch 
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.proximal_aortic_arch} onChange={(value) => { setAortaData({...aortaData, proximal_aortic_arch: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 31.7 
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Mid Aortic Arch
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.mid_aortic_arch} onChange={(value) => { setAortaData({...aortaData, mid_aortic_arch: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 31.0 
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Proximal Descending Aorta 
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.proximal_descending_aorta} onChange={(value) => { setAortaData({...aortaData, proximal_descending_aorta: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 30.5 
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Mid Descending Aorta 
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.mid_descending_aorta} onChange={(value) => { setAortaData({...aortaData, mid_descending_aorta: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 30.0  
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Aorta at Diaphragm
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.aorta_at_diaphragm} onChange={(value) => { setAortaData({...aortaData, aorta_at_diaphragm: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 29.0  
                                </td>
                            </tr>                            
                            <tr>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    Aorta at Celiac artery origin
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    <EditableText  value={ aortaData.aorta_at_celiac_artery_origin} onChange={(value) => { setAortaData({...aortaData, aorta_at_celiac_artery_origin: value});}}/>
                                </td>
                                <td style={mobile ? styles.tableItemMobile : styles.tableItem}>
                                    &lt; 29.1  
                                </td>
                            </tr>                            
                        </table> */}
            </div>
          </div>
        </div>
      ) : (
        <CircularProgress style={{ margin: "20px" }} />
      )}
      <Modal
        open={cacModalOpen}
        onClose={() => {
          setCacModalOpen(false);
        }}
      >
        <div style={styles.modal}>
          <div style={styles.modalHeader}>
            <h1 style={styles.modalHeaderText}>Add Impression</h1>

            <Select
              style={{ width: "100%", margin: "10px" }}
              value={newCacData["side"]}
              onChange={(e) => {
                setNewCacData({ ...newCacData, side: e.target.value });
              }}
            >
              <MenuItem value={"LeftKidney"}>Left</MenuItem>
              <MenuItem value={"RightKidney"}>Right</MenuItem>
              <MenuItem value={"Bladder"}>Bladder</MenuItem>
            </Select>

            <div style={styles.modalFooter}>
              <Button
                onClick={() => {
                  // Add stone to cacsData
                  // setCacsData({...cacsData, [stoneIndex]: newCacData});

                  console.log(newCacData, cacsData, "cacsData");
                  setCacsData((prevStonesData) => {
                    return {
                      ...prevStonesData,
                      [`stone_${Object.keys(cacsData).length + 1}`]: newCacData,
                    };
                  });
                  setCacModalOpen(false);
                  // setStoneIndex(stoneIndex + 1);
                }}
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
